/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Robot_Hud_BatteryInputs */

const en_robot_hud_battery = /** @type {(inputs: Robot_Hud_BatteryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Battery`)
};

const fr_robot_hud_battery = /** @type {(inputs: Robot_Hud_BatteryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Batterie`)
};

const ms_sg2_robot_hud_battery = /** @type {(inputs: Robot_Hud_BatteryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bateri`)
};

/**
* | output |
* | --- |
* | "Battery" |
*
* @param {Robot_Hud_BatteryInputs} inputs
* @param {{ locale?: "en" | "fr" | "ms-SG" }} options
* @returns {LocalizedString}
*/
export const robot_hud_battery = /** @type {((inputs?: Robot_Hud_BatteryInputs, options?: { locale?: "en" | "fr" | "ms-SG" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Robot_Hud_BatteryInputs, { locale?: "en" | "fr" | "ms-SG" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_robot_hud_battery(inputs)
	if (locale === "fr") return fr_robot_hud_battery(inputs)
	return ms_sg2_robot_hud_battery(inputs)
});